// extracted by mini-css-extract-plugin
export var searchHeader = "_9z-0";
export var searchHeaderDark = "_9z-1";